import {DataObjectId, Hub} from 'yougile-model'
import {Sync} from './sync'

export class EmployeeSettings {
  public static getPosition(userId: DataObjectId): string {
    if (!userId) {
      return ''
    }
    const box = Sync.getCurrentSandbox()
    const c = box.get(box.companyId) as Hub
    return c.data.employeeSettings && c.data.employeeSettings[userId]
      ? c.data.employeeSettings[userId].position || ''
      : ''
  }
}
